<!-- Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. -->

<h1>{{ appStrings.SIGN_UP }}</h1>
<form class="core-container-content" [formGroup]="signUpValidationForm" (ngSubmit)="continueSignUp()">
	<mat-form-field>
		<mat-label>{{ appStrings.EMAIL }}</mat-label>
		<input matInput autocomplete="username" formControlName="email" />
		<mat-error>{{ appStrings.ENTER_VALID_EMAIL }}</mat-error>
	</mat-form-field>

	<button-footer
		class="mat-form-field-compatible-spacing"
		[disabled]="!signUpValidationForm.valid"
		[saveOrCloseButtonText]="appStrings.WIZARD_CONTINUE"
	>
	</button-footer>
</form>

<div class="mat-form-field-compatible-spacing">
	{{ appStrings.ALREADY_HAVE_ACCOUNT }}
	<a [routerLink]="'../login'" queryParamsHandling="preserve">{{ appStrings.LOG_IN }}</a>
</div>
